module.exports = __webpack_public_path__ + "img/logo_black.18ed444e.svg";